import React from "react";
import { Accordion } from "./Accordion";
import { SettingsIcon, MailIcon } from "lucide-react";
import { SUPPORT_EMAIL } from "../data/constants";
const OBJECTIONS = [{
  emoji: "❓",
  title: "¿Sirve para mi caso si mi antepasado es bisabuelo o tatarabuelo?",
  content: "La guía te enseña a evaluar tu línea generación por generación y a detectar los puntos que pueden afectar la transmisión, incluyendo la reforma de 2025. No promete un resultado, pero te da un método claro para entender tu situación antes de gastar en partidas y traducciones, y para saber cuándo conviene una consulta profesional."
}, {
  emoji: "💻",
  title: "No soy bueno con la computadora, ¿lo voy a poder usar?",
  content: "Sí. Está escrito en lenguaje simple, paso a paso, con modelos listos para copiar y pegar y un Excel con menús desplegables. Muchos de nuestros lectores tienen más de 55 años y lo usan sin problema."
}, {
  emoji: "💳",
  title: "¿Cómo lo recibo después de pagar?",
  content: "Es 100% digital. Apenas confirmás el pago recibís el acceso al PDF y a los bonos de forma inmediata en tu correo. No esperás envíos ni nada físico."
}, {
  emoji: "💰",
  title: "¿No es más barato hacerlo con un gestor?",
  content: "Los gestores suelen cobrar mucho más y no siempre cumplen los plazos que prometen. Este kit te da autonomía para hacer gran parte del trabajo vos mismo y saber exactamente en qué vale la pena invertir."
}, {
  emoji: "🔄",
  title: "¿Y si tengo dudas después de comprar?",
  content: "Tenés nuestro correo de soporte para escribirnos cualquier consulta sobre el material. Estamos para ayudarte a aprovecharlo al máximo."
}];
export function Objections() {
  return <section className="w-full bg-beige px-5 py-10" data-id="element-95" data-mp="2tzjfnehkgc3j">
      <div className="mx-auto max-w-md" data-id="element-96" data-mp="2txzy7kk6bv06">
        <h2 className="text-center font-serif text-2xl font-bold text-deep-green" data-id="element-97" data-mp="2yymm93d72qdm">
          Preguntas frecuentes
        </h2>
        <p className="mt-2 text-center text-sm text-ink/70" data-id="element-98" data-mp="15g6u4w6uxtvn">
          Resolvé tus dudas antes de empezar.
        </p>

        <div className="mt-6" data-id="element-99" data-mp="10i5aoa5irsjn">
          <Accordion items={OBJECTIONS} variant="green" data-id="element-100" data-mp="10ix71n6xxuaz" />
        </div>

        <div className="mt-8 flex flex-col items-center gap-2 rounded-2xl border border-sand bg-cream p-5 text-center" data-id="element-101" data-mp="voj9be4t3b35">
          <SettingsIcon className="h-8 w-8 text-italian-green" aria-hidden="true" data-id="element-102" data-mp="qowwv6wsxyve" />
          <p className="text-sm font-semibold text-ink" data-id="element-103" data-mp="hqcj8k63mfe1">Soporte</p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="flex items-center gap-2 text-sm font-semibold text-italian-green underline decoration-gold/60 underline-offset-4" data-id="element-104" data-mp="horrf2b65ajv">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-105" data-mp="7tzttyhl6np3" />
            {SUPPORT_EMAIL}
          </a>
        </div>

        <p className="mt-6 text-center text-[11px] leading-relaxed text-ink/50" data-id="element-106" data-mp="272wsw6sj14dd">
          Este material es una guía educativa y no constituye asesoramiento
          legal. No garantiza turnos, plazos ni resultados. Cada caso puede
          requerir la consulta de un profesional.
        </p>
      </div>
    </section>;
}